import { render, staticRenderFns } from "./versionInfo.vue?vue&type=template&id=2b45089e&"
import script from "./versionInfo.vue?vue&type=script&lang=ts&"
export * from "./versionInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports